<template>
    <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="驳回提示">
        <div>确定要驳回吗?</div>
        <div slot="footer">
            <el-button @click="noDialog">取 消</el-button>
            <el-button type="primary" @click="unbindGet">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import dialogMixin from "@/mixin/dialogMixin";
    import resDisposeMixin from "@/mixin/resDisposeMixin";
    import memberCarApi from "@/api/device/UserCar";
    export default {
        name: "showAgentRejectCar",
        props: {
            deviceId: Number
        },
        mixins: [dialogMixin, resDisposeMixin],
        methods: {
            unbindGet() {
                memberCarApi.agentRejectCar(this.deviceId).then(res => {
                    this.resNoDialog({res})

                  if(this.$parent.$options._componentTag=='NeedCheckUserCar') {
                    this.$parent.$parent.$parent.$children[1].$children[0].fetchData()
                  }
                  if(this.$parent.$options._componentTag=='AllUserCar') {
                    this.$parent.$parent.$parent.$children[2].$children[0].fetchData()
                  }
                })
            },
        }
    }
</script>
